import { vuex as auth } from './auth';
import { vuex as appointment } from './appointment';
import { vuex as surgeryAppointment } from './surgery-appointment';
import { vuex as attendance } from './attendance';
import { vuex as doctoralia } from './doctoralia';

const vuex = {
  auth,
  appointment,
  surgeryAppointment,
  attendance,
  doctoralia,
};
const keys = Object.keys(vuex);

const modules = keys.reduce((acc, key) => ({ ...acc, [key]: vuex[key].module }), {});
const plugins = keys.reduce((acc, key) => [...acc, vuex[key].plugin], []);

export default { modules, plugins };
